import { useAuth0 } from "@auth0/auth0-react";
import { useConnectorsWithCreator } from "hooks/useConnectorsWithCreator";
import { useOwnedConnectors } from "hooks/useOwnedConnectors";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

export const useSlugConnector = (shouldFetch = true) => {
  const { ownedConnectors: ownedComponents, handleFetchOwnedConnectors } = useOwnedConnectors();
  const params = useParams();
  const { connectorsWithCreator, connectorCreators, handleFetchConnectorsWithCreators } =
    useConnectorsWithCreator();
  const { user } = useAuth0();
  const { sharedConnectors } = useSelector((store) => store.portal.connectors);

  const component = ownedComponents?.find((component) => component.id === params.slug);
  const connector = connectorsWithCreator?.find((connector) => connector.id === params.slug);

  const currentUserShared = sharedConnectors?.find(
    (sc) => sc.shared_user_id === user.sub && sc.connector_id === connector?.id
  );

  const isReadOnlyAccess = currentUserShared?.access_type === "readOnly";

  useEffect(() => {
    if (shouldFetch) {
      handleFetchConnectorsWithCreators(ownedComponents);
    }
  }, [ownedComponents?.length]);

  return {
    connector: {
      ...(connector ? connector : {}),
      ...(component ? component : {})
    },
    connectorCreators,
    handleFetchOwnedConnectors,
    isReadOnlyAccess
  };
};
